import React from 'react';
import styled from 'styled-components';

type DotProps = {
  isActive: boolean;
};

const Dot = styled.span<DotProps>(
  ({ isActive, theme }) => `
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.5rem;
  border-radius: 50%;
  display: inline-block;
  background-color: ${theme.colors[isActive ? 'grey20' : 'grey10']};
`,
);

const ActivityIndicator = ({ pageCount, currentPage }: { pageCount: number; currentPage: number }) => {
  const dots = [];
  for (let i = 1; i <= pageCount; i += 1) {
    const isActive = currentPage === i;
    dots.push(<Dot key={i} isActive={isActive} aria-current={isActive} />);
  }
  return (
    <div role="group" aria-label={`Viewing page ${currentPage} of ${pageCount}`}>
      {dots}
    </div>
  );
};

export default ActivityIndicator;
